import React from 'react';
import styled from 'styled-components/macro';
import { Skeleton } from 'antd';
import { Colors } from '@cognite/cogs.js';
import { useFeatureFlag, FeatureFlags } from 'utils/feature-flags';
import { DigitalTwins } from './components';

export const AllDigitalTwinsPage = () => {
  const enabledDigitalTwins = useFeatureFlag(FeatureFlags.enabledDigitalTwins);

  return (
    <StyledContainer>
      <StyledContentPanel>
        {enabledDigitalTwins ? <DigitalTwins /> : <Skeleton />}
      </StyledContentPanel>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  background-color: var(--cogs-bg-accent);
`;

const StyledContentPanel = styled.div`
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;
